import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { MaskLines, Reveal } from "../components/Motion";
import { useFetch } from "../lib/useFetch";
import { money } from "../lib/api";
import { useCart } from "../context/CartContext";

export default function Shop() {
  const { data } = useFetch("/catalog", { plans: [], products: [] });
  const products = Array.isArray(data?.products) ? data.products : [];
  const { add } = useCart();
  return (
    <div className="px-5 lg:px-12 pt-14" data-testid="shop-page">
      <div className="grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          <p className="eyebrow mb-6">The BPJ Store</p>
          <h1 className="f-serif text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[0.95]"><MaskLines lines={["Print worth", <em key="k" className="font-light">keeping.</em>]} /></h1>
        </div>
        <p className="lg:col-span-4 lg:col-start-9 text-lg text-[var(--ink-2)] leading-relaxed">Single issues, cloth-bound volumes and digital research packs. Printed on uncoated stock, shipped worldwide.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16 mt-20">
        {products.map((p, i) => (
          <Reveal key={p.id} delay={(i % 3) * 0.08}>
            <div className="group" data-testid={`product-${p.id}`}>
              <div className="relative aspect-[4/5] bg-[var(--paper-2)] overflow-hidden grid place-items-center">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.9),transparent_60%)]" />
                <motion.img src={p.image} alt={p.name} whileHover={{ y: -10, rotate: -1.5 }} transition={{ type: "spring", stiffness: 200, damping: 18 }}
                  className={`relative ${p.image.includes("product") ? "w-full h-full object-cover" : "w-[58%] shadow-[0_40px_50px_-25px_rgba(0,0,0,0.55)]"}`} loading="lazy" />
                <span className="absolute top-4 left-4 eyebrow bg-[var(--paper)] px-2 py-1 !text-[0.6rem]">{p.kind}</span>
              </div>
              <div className="flex items-start justify-between gap-4 mt-5">
                <div><h3 className="f-serif text-2xl leading-tight">{p.name}</h3><p className="text-[var(--muted)] mt-1">{p.subtitle}</p></div>
                <p className="f-mono text-lg" data-testid={`product-price-${p.id}`}>{money(p.price)}</p>
              </div>
              <button onClick={() => { add(p); toast.success(`${p.name} added to your bag`); }} className="btn-line mt-5 w-full h-11 flex items-center justify-center gap-2 font-semibold" data-testid={`add-to-cart-${p.id}`}>
                <Plus size={16} /> Add to bag
              </button>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
